module.exports = __webpack_public_path__ + "static/california-condors-08441285c4f547b8cf5f7f9efa345071.jpg";